import {WixSdk} from '@wix/js-sdk-wrapper';
import {Observable} from 'rxjs';

export const pubSub = <T>(
  eventName: string,
  onlyFromCurrentOrigin = true,
  receivePastEvents = false,
): Observable<T> => {
  const compId = WixSdk.Utils.getCompId();

  return new Observable((subscriber) => {
    const id = WixSdk.PubSub.subscribe(
      eventName,
      (event: {data: any; origin: string}) => {
        let origin = event.origin;
        let data = event.data || {};

        if (/\.track$/.test(eventName)) {
          origin = data[0];
          data = data.slice(1);
        }
        const isEventFromCurrentOrigin = origin === compId || data.targetComponentId === compId;

        if (isEventFromCurrentOrigin === onlyFromCurrentOrigin) {
          subscriber.next(data);
        }
      },
      receivePastEvents,
    );
    return () => {
      WixSdk.PubSub.unsubscribe(eventName, id);
    };
  });
};
